<template>
  <div>
  <!-- <Header /> -->
  <div class="pricingplan-page">
  <!-- <CommonHeader /> -->
  <v-card class="tab-card"
  >
    <v-tabs
      v-model="tab"
    >
      <v-tabs-slider></v-tabs-slider>

      <!-- <v-tab href="#tab-1" class="tabs-box" @click.prevent.stop="CheckTab('monthly')" v-if="current_plan_type == 'monthly'">
          MONTHLY
      </v-tab>
 -->
      <v-tab href="#tab-2" class="tabs-box" @click.prevent.stop="CheckTab('annual')">
          ANNUAL
      </v-tab>

    </v-tabs>

    <v-tabs-items v-model="tab" class="tabs-content">
      <!-- <v-tab-item
        value="tab-1"
        v-if="(tabName=='monthly') && (current_plan_type == 'monthly')"
      >
         <MonthlyComponent />
          
      </v-tab-item> -->
      <v-tab-item
        value="tab-2"
        v-if="(tabName=='annual') || (current_plan_type == 'yearly')"
      >
       <YearlyComponent />
      </v-tab-item>

      
    </v-tabs-items>
  </v-card>
</div>
</div>
</template>

<script>
  import YearlyComponent from './YearlyComponent.vue';
  import MonthlyComponent from './MonthlyComponent.vue';
  export default {
    components: {
      MonthlyComponent,
      YearlyComponent,
    },
    data () {
      return {
        tab: null,
        text: 'text1',
        tabName: 'annual',
        current_plan_type:'',
      }
    },
    created(){
      // this.tabName = (this.authUser.monthly_plan.length=='0')?'annual':'monthly';
      // this.current_plan_type = (this.authUser.monthly_plan.length=='0')?'annual':'monthly'; 
      this.tabName = 'annual';
      this.current_plan_type = 'annual'; 
    },
    methods:{
      CheckTab(tabName) {
        this.tabName = tabName;
      }
    },
  }
</script>